import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters';

Vue.use(Vuex)

// 数据
const state = {
  logined: false, // 是否已经登录
  userIp: '', // ip地址
  allFundItems: [], // 所有基金列表
  collectFundItems: [], // 收藏的基金列表
  hotSells: [], // 热销基金
  fundInfo: {}, // 基金信息
  fundTypeList: [], // 基金类型字典列表
  page: 0,
  isLoading: false, // 页面等待loading
  allSLoading: false, // 全屏loading
  diviendRecord: [], // 分红记录
  comeInPage: null, // 首页入口tab， 0为首页，1为理财， 2位个人中心
  cardDetail: {}, // 银行卡详情
  result: {}, // 结果页面数据
  scrollLoading: null, // 理财全部列表页面的scroll标志
  fundType: null, // 理财全部列表页面的基金类型
  fundTypeNum: null, // 理财全部列表页面的基金类型
  trarajectory: { // 基金信息 业绩走势
    fundCode: '',
    nav: []
  },
  fundAssetList: [], // 持有基金列表
  userInfo: {}, // 用户信息
  isBindCard: true, // 用户是否绑卡
  isCertVaild: '1', // 是否实名认证并在有效期
  userOpenIdInfo: {}, // 用户登录opendId相关信息
  clearBuyInput: false,
  tabBarNumber: 0,
  hotline: '',
}
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js